import 'normalize.css/normalize.css'
import 'swiper/dist/css/swiper.css'
import '@/global.sass'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import axios from 'axios'

import App from '@/App.vue'
import store from '@/store'

Vue.use(VueScrollTo)

Vue.config.productionTip = false
Vue.http = axios
Vue.prototype.$http = axios

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
